/**
 * 페이지 네비게이션 관련 유틸리티 함수들
 */

/**
 * 활성화된 페이지들 중에서 현재 페이지의 이전/다음 페이지를 찾는 함수
 * @param {string} currentPageType - 현재 페이지 타입
 * @param {Array} presetPageMasters - 전체 페이지 마스터 목록
 * @returns {Object} { prevPage, nextPage, currentPage }
 */
export const findActiveNeighborPages = (currentPageType, presetPageMasters) => {
  if (!currentPageType || !presetPageMasters || !Array.isArray(presetPageMasters)) {
    return { prevPage: null, nextPage: null, currentPage: null };
  }

  // 모든 페이지를 displayOrder로 정렬
  const allPages = [...presetPageMasters].sort((a, b) => a.displayOrder - b.displayOrder);
  
  // 현재 페이지의 인덱스 찾기
  const currentIndex = allPages.findIndex(page => page.pageType === currentPageType);
  if (currentIndex === -1) {
    return { prevPage: null, nextPage: null, currentPage: null };
  }
  
  // 현재 페이지로부터 이전 활성 페이지 찾기
  let prevPage = null;
  for (let i = currentIndex - 1; i >= 0; i--) {
    if (allPages[i].isActive) {
      prevPage = allPages[i];
      break;
    }
  }
  
  // 현재 페이지로부터 다음 활성 페이지 찾기
  let nextPage = null;
  for (let i = currentIndex + 1; i < allPages.length; i++) {
    if (allPages[i].isActive) {
      nextPage = allPages[i];
      break;
    }
  }
  
  return {
    prevPage,
    nextPage,
    currentPage: allPages[currentIndex]
  };
};

/**
 * 타이머 리다이렉트 옵션을 생성하는 함수
 * @param {string} currentPageType - 현재 페이지 타입
 * @param {Array} presetPageMasters - 전체 페이지 마스터 목록
 * @returns {Array} 리다이렉트 옵션 배열
 */
export const getTimerRedirectOptions = (currentPageType, presetPageMasters) => {
  const { prevPage, nextPage } = findActiveNeighborPages(currentPageType, presetPageMasters);
  
  return [
    { 
      value: 'start', 
      label: '시작 페이지',
      available: true 
    },
    { 
      value: 'prev', 
      label: prevPage ? `이전 페이지 (${prevPage.name})` : '이전 페이지 (없음)',
      available: !!prevPage 
    },
    { 
      value: 'next', 
      label: nextPage ? `다음 페이지 (${nextPage.name})` : '다음 페이지 (없음)',
      available: !!nextPage 
    }
  ];
};

/**
 * 기존 timerRedirectPage 값을 새로운 타입으로 마이그레이션
 * @param {string} oldValue - 기존 값 (URL 형태)
 * @param {string} currentPageType - 현재 페이지 타입
 * @returns {string} 'start', 'prev', 'next' 중 하나
 */
export const migrateTimerRedirectValue = (oldValue, currentPageType) => {
  // 이미 새 형식인 경우
  if (['start', 'prev', 'next'].includes(oldValue)) {
    return oldValue;
  }
  
  // 시작 페이지 관련 값들
  if (!oldValue || oldValue === 'start' || oldValue === '/index' || oldValue === 'index') {
    return 'start';
  }
  
  // 기본값은 start로 설정
  return 'start';
};